import React from "react";
import { Input } from "@trussle/external-components";
import { useCalculatorStore } from "../store";
import { calculateMonthlyRepaymentAmount } from "../../CalculatorPanels/calculatorMethods";
import { CalculatorTabLayout } from "../CalculatorTabLayout";

import "./styles.scss";
import { Hr } from "../_Atoms/Hr";

const Disclaimer = (
  <div className="calculator-panel-v2__disclaimer">
    You may have to pay an early repayment charge if you remortgage.
    <br />
    Your home could be repossessed if you don't keep up repayments on your mortgage.
    <br />
    This calculator is only an estimate of how much you may be able to borrow. Talk to a mortgage broker or lender to get a more accurate
    figure.
  </div>
);

export const AffordabilityCalculator: React.FunctionComponent = () => {
  const {
    mortgageAmount,
    mortgageTerm,
    mortgageInterestRate,
    setMortgageAmount,
    setMortgageTerm,
    setMortgageInterestRate,
  } = useCalculatorStore();

  const monthlyInterestRate = (parseFloat(mortgageInterestRate) || 0) / 100 / 12;
  const numberOfMonths = mortgageTerm !== undefined ? parseInt(mortgageTerm, 10) * 12 : 30 * 12;

  const monthlyPayments = Math.round(
    calculateMonthlyRepaymentAmount(
      Number(mortgageAmount.replace(/,/g, "")),
      Number(monthlyInterestRate),
      Number(numberOfMonths),
    ),
  );

  const form = (
    <>
      <Input
        betterV2
        variant="currency"
        name="Mortgage amount"
        label="Mortgage amount"
        inputSize="large"
        id="affordability-calculator-mortgage-amount"
        data-testid="affordability-calculator-mortgage-amount"
        classOverrides={{ inputContainer: "calculator-input" }}
        value={mortgageAmount}
        required
        onChange={(e) => {
          setMortgageAmount(e.target.value);
        }}
      />
      <Input
        betterV2
        variant="year"
        name="Mortgage term"
        label="Mortgage term"
        inputSize="large"
        id="affordability-calculator-mortgage-term"
        data-testid="affordability-calculator-mortgage-term"
        classOverrides={{ inputContainer: "calculator-input" }}
        value={mortgageTerm}
        onChange={(e) => {
          setMortgageTerm(e.target.value);
        }}
      />
      <Input
        betterV2
        variant="percentage"
        name="Mortgage interest rate"
        label="Mortgage interest rate"
        inputSize="large"
        id="affordability-calculator-mortgage-interest-rate"
        data-testid="affordability-calculator-mortgage-interest-rate"
        classOverrides={{ inputContainer: "calculator-input" }}
        value={mortgageInterestRate}
        required
        onChange={(e) => {
          setMortgageInterestRate(e.target.value);
        }}
      />
    </>
  )

  const result = (
    <div className="affordability-calculator">
      <div className="calculator-panel-v2__horizontal-line calculator-panel-v2__result__header">
        <h3>Your monthly mortgage repayments</h3>
        <span>
          {monthlyPayments > 0 ? `£${monthlyPayments.toLocaleString("en-GB")}` : null}
        </span>
      </div>
      <Hr />
      <div className="calculator-panel-v2__vertical-line">
        <h4 className="affordability-calculator__fees-title">Other fees you may have to pay:</h4>
        <div className="calculator-panel-v2__horizontal-line broker-fee">
          <p>Broker fee (with Better.co.uk)</p>
          <span className="green-badge">Free</span>
        </div>
        <div className="calculator-panel-v2__horizontal-line">
          <p>Additional fees</p>
          <a
            href="https://better.co.uk/mortgages/buying-a-house"
            aria-label="Better.co.uk buying a house page"
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  )

  return (
    <CalculatorTabLayout
      variant="Affordability"
      form={form}
      result={result}
      disclaimer={Disclaimer}
    />
  );
};
